import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-start align-center"
}
const _hoisted_5 = { class: "mr-5" }
const _hoisted_6 = {
  key: 1,
  class: "text-disabled mt-3"
}
const _hoisted_7 = {
  class: "d-flex",
  style: {"cursor":"pointer"}
}
const _hoisted_8 = {
  style: {"color":"red"},
  class: "mt-2"
}

import { computed, onBeforeUnmount, ref, Ref } from 'vue'
import {
  ToolsService,
  AppType,
  MunicipalEntitiesService,
  Id,
  ExportStatus,
  ConnectionStatusService,
  ConnectionStatus,
  Permissions,
  hasUserPermission,
  AppAuthService,
  UpdatePlatform,
  enumGetValues,
} from '@prodcard/core'
import { createCtx, handleError, detectOS } from '../../../helpers'
import { VMunicipalEntitiesSelect } from '../../../components'
import { useTheme } from 'vuetify'
import VueDatePicker, { ModelValue } from '@vuepic/vue-datepicker'
import { endOfYear, endOfMonth, endOfQuarter, format } from 'date-fns'
import { cloneDeep } from 'lodash'
import { refObservableValue } from '@prodcard/apps-vue'

interface MonthInfo {
  month: number
  year: number
}

interface Period {
  value: string
  title: string
}

interface DonwloadLink {
  platform: UpdatePlatform
  link: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportTab',
  props: {
    toolsService: {},
    authService: {},
    connectionStatusService: {},
    municipalEntitiesService: {}
  },
  setup(__props: any) {

const props = __props;



const exportStatus: Ref<ExportStatus | undefined> = ref(props.toolsService.exportStatus.value)
const exportStatusWatcher = props.toolsService.exportStatus.subscribe(status => {
  exportStatus.value = status
})

const currentUserPermissions = refObservableValue(props.authService.permissions)
const canSelectMo = computed(() => {
  return hasUserPermission(currentUserPermissions.value, Permissions.TOOLS_EXPORT_MO_VIEW)
})
const canSelectOpts = computed(() => {
  return hasUserPermission(currentUserPermissions.value, Permissions.TOOLS_EXPORT_OPTS_VIEW)
})

const downloadLink = computed(() => {
  return loadedLinks.value.find(v => v.platform === platform.value)?.link
})
const isLoading = ref(false)
const writeOpts = ref({
  writeDistro: true,
  writeData: true,
  createAuthCode: true,
  path: '',
})
const currentAppType = props.toolsService.currentAppType(createCtx())
const municipalEntityId: Ref<Id | undefined> = ref()
const theme = useTheme()
const datePicker = ref()
const modelValue: Ref<ModelValue> = ref(new Date())
const range: Ref<[Date, Date] | undefined> = ref()
const selectorDisabled = ref(false)
const errorMessage = ref('')
let connectionStatus: Ref<ConnectionStatus | undefined>
if (props.connectionStatusService) {
  connectionStatus = refObservableValue(props.connectionStatusService.networkStatus)
} else {
  connectionStatus = ref(undefined)
}

const defaultPeriods = [
  { value: 'all', title: 'Весь период' },
  { value: 'year', title: 'Год' },
  { value: 'quarter', title: 'Квартал' },
  { value: 'month', title: 'Месяц' },
  { value: 'week', title: 'Неделя' },
]
const periods = ref<Period[]>(cloneDeep(defaultPeriods))
const period: Ref<string> = ref(periods.value[0].value)
const platform: Ref<UpdatePlatform> = ref(UpdatePlatform.WINDOWS)
const loadedLinks: Ref<DonwloadLink[]> = ref([])
const currentOs = detectOS()
if (currentOs && enumGetValues(UpdatePlatform).includes(currentOs)) {
  platform.value = currentOs as UpdatePlatform
}

const loadLink = () => {
  if (currentAppType === AppType.DESKTOP || loadedLinks.value.find(v => v.platform === platform.value)) {
    return
  }
  handleError(async () => {
    const link = await props.toolsService.getDownloadLink(createCtx(), platform.value)
    if (link) {
      loadedLinks.value.push({ platform: platform.value, link })
    }
  }, isLoading)
}
loadLink()

const pickDir = async () => {
  const dir = await props.toolsService.pickDirectory(createCtx())
  writeOpts.value.path = dir || ''
}

const toggleMenu = (per: string | undefined) => {
  if (!per) {
    return
  }

  switch (per) {
    case 'all':
      range.value = undefined
      return

    case 'year':
      modelValue.value = new Date().getFullYear()
      break

    case 'week':
      modelValue.value = [new Date(), new Date()]
      break

    default:
      modelValue.value = new Date()
  }

  selectorDisabled.value = true
  datePicker.value.openMenu()
}

const clearSelect = () => {
  modelValue.value = new Date()
  range.value = undefined
  period.value = periods.value[0].value
  updatePeriods()
}

const updatePeriods = () => {
  periods.value = cloneDeep(defaultPeriods).map(p => {
    if (p.value === period.value && range.value) {
      p.title = `${p.title} (${new Date(range.value[0]).toLocaleDateString()} - ${new Date(
        range.value[1],
      ).toLocaleDateString()})`
    }
    return p
  })
}

const exportData = () => {
  errorMessage.value = ''
  if (!(writeOpts.value.writeData || writeOpts.value.writeDistro || writeOpts.value.path)) {
    errorMessage.value = 'Выберите параметры экспорта'
    return
  }
  if ((writeOpts.value.writeData || writeOpts.value.writeDistro) && !writeOpts.value.path) {
    errorMessage.value = 'Выберите путь сохранения'
    return
  }
  handleError(async () => {
    await props.toolsService.export(createCtx(), {
      writeDistro: writeOpts.value.writeDistro && connectionStatus.value === ConnectionStatus.ONLINE,
      writeData: writeOpts.value.writeData,
      createAuthCode: writeOpts.value.createAuthCode,
      range: range.value,
      moId: municipalEntityId.value,
      platform: platform.value,
      path: writeOpts.value.path,
    })
  })
}

const updateDate = (date: ModelValue) => {
  if (!date) return

  modelValue.value = date
  switch (period.value) {
    case 'year':
      const year = date as number
      const yearStart = new Date(year, 0, 1)
      range.value = [yearStart, endOfYear(yearStart)]
      break
    case 'quarter':
      const quarterStart = new Date(date as string)
      range.value = [quarterStart, endOfQuarter(quarterStart)]
      break
    case 'month':
      const monthInfo = date as MonthInfo
      const monthStart = new Date(monthInfo.year, monthInfo.month, 1)
      range.value = [monthStart, endOfMonth(monthStart)]
      break
    case 'week':
      const weekInfo = date as [Date, Date]
      range.value = weekInfo
      break
    default:
      range.value = undefined
  }
  updatePeriods()
}

onBeforeUnmount(() => {
  props.toolsService.exportStatus?.unsubscribe(exportStatusWatcher)
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(currentAppType) === _unref(AppType).WEB)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_btn, {
            href: downloadLink.value,
            loading: isLoading.value,
            disabled: isLoading.value,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Скачать дистрибутив")
            ]),
            _: 1
          }, 8, ["href", "loading", "disabled"]),
          _createVNode(_component_v_radio_group, {
            modelValue: platform.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((platform).value = $event)),
              loadLink
            ],
            inline: "",
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio, {
                label: "Windows",
                value: _unref(UpdatePlatform).WINDOWS
              }, null, 8, ["value"]),
              _createVNode(_component_v_radio, {
                label: "Linux",
                value: _unref(UpdatePlatform).LINUX
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_unref(currentAppType) === _unref(AppType).DESKTOP)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.municipalEntitiesService && canSelectMo.value)
            ? (_openBlock(), _createBlock(_unref(VMunicipalEntitiesSelect), {
                key: 0,
                modelValue: municipalEntityId.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((municipalEntityId).value = $event)),
                "municipal-entities-service": _ctx.municipalEntitiesService,
                density: "comfortable"
              }, null, 8, ["modelValue", "municipal-entities-service"]))
            : _createCommentVNode("", true),
          (canSelectOpts.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_unref(connectionStatus) === _unref(ConnectionStatus).ONLINE)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_v_checkbox, {
                          modelValue: writeOpts.value.writeDistro,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((writeOpts.value.writeDistro) = $event)),
                          label: "Записать дистрибутив",
                          "hide-details": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createVNode(_component_v_radio_group, {
                        modelValue: platform.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((platform).value = $event)),
                        inline: "",
                        "hide-details": "",
                        disabled: !writeOpts.value.writeDistro
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            label: "Windows",
                            value: _unref(UpdatePlatform).WINDOWS
                          }, null, 8, ["value"]),
                          _createVNode(_component_v_radio, {
                            label: "Linux",
                            value: _unref(UpdatePlatform).LINUX
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_6, "Загрузка дистрибутива доступна только при активном соединении")),
                _createVNode(_component_v_checkbox, {
                  modelValue: writeOpts.value.writeData,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((writeOpts.value.writeData) = $event)),
                  label: "Записать данные",
                  "hide-details": ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_checkbox, {
                  modelValue: writeOpts.value.createAuthCode,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((writeOpts.value.createAuthCode) = $event)),
                  label: "Создать код регистрации",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(VueDatePicker), {
            ref_key: "datePicker",
            ref: datePicker,
            "model-value": modelValue.value,
            format: "dd.MM.yyyy",
            "text-input": {
        openMenu: false,
      },
            "enable-time-picker": false,
            clearable: false,
            "auto-apply": "",
            locale: "ru-RU",
            position: "left",
            dark: _unref(theme).global.name.value === 'dark',
            "year-picker": period.value === 'year',
            "month-picker": period.value === 'month',
            "quarter-picker": period.value === 'quarter',
            "week-picker": period.value === 'week',
            "onUpdate:modelValue": updateDate,
            utc: "",
            teleport: 'body',
            config: { onClickOutside: () => {} },
            onClosed: _cache[8] || (_cache[8] = ($event: any) => (selectorDisabled.value = false))
          }, {
            "dp-input": _withCtx(({}) => [
              _createVNode(_component_v_select, {
                label: "Временной период выгрузки данных",
                disabled: selectorDisabled.value,
                clearable: period.value !== 'all',
                density: "comfortable",
                items: periods.value,
                modelValue: period.value,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((period).value = $event)),
                  _cache[7] || (_cache[7] = ($event: any) => (toggleMenu($event)))
                ],
                "onClick:clear": clearSelect,
                class: "mt-3"
              }, null, 8, ["disabled", "clearable", "items", "modelValue"])
            ]),
            quarter: _withCtx(({ value }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(format)(value, 'Q квартал')), 1)
            ]),
            _: 1
          }, 8, ["model-value", "dark", "year-picker", "month-picker", "quarter-picker", "week-picker"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_text_field, {
              "onClick:appendInner": pickDir,
              modelValue: writeOpts.value.path,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((writeOpts.value.path) = $event)),
              density: 'comfortable',
              class: "mt-3",
              "append-inner-icon": 'mdi-folder',
              label: 'Путь сохранения',
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_v_btn, {
            class: "mt-3",
            onClick: exportData,
            loading: exportStatus.value?.isExporting,
            disabled: exportStatus.value?.isExporting
          }, {
            default: _withCtx(() => [
              _createTextVNode("Выгрузить данные")
            ]),
            _: 1
          }, 8, ["loading", "disabled"]),
          _createElementVNode("p", _hoisted_8, _toDisplayString(errorMessage.value || exportStatus.value?.errorMessage), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})